module.exports = __webpack_public_path__ + "img/21.aa1cc919.jpg";